import { Opacity } from "@mui/icons-material";
import { useMediaQuery } from "@mui/material";
import { createTheme, useTheme } from "@mui/material/styles";
import { useState, useMemo, createContext } from "react";
import { ColorModeContextType } from "./types/ui/theme.types.ts";
import { useTranslation } from "react-i18next";


// bgcolor:'#161B25' ,

export const tokens = (mode) => ({
  ...(mode === "dark"
    ? {
      primary: {
        100: "#E9F4F4",
        200: "#BBDDDE",
        300: "#9ACDCE",
        400: "#6CB6BB",
        500: "#4FA8AA",
        600: "#208588",
        700: "#1D797C",
        800: "#19686A",
        900: "#135052",
        1000: "#0F3D3F",
        1100: "#082021",
      },
      gray: {
        100: "#F1F1F2",
        200: "#D3D3D6",
        300: "#BEBEC2",
        400: "#A0A0A6",
        500: "#8D8D95",
        600: "#67676F",
        700: "#5D5D65",
        800: "#505057",
        900: "#3E3E43",
        1000: "#2F2F33",
        1100: "#ffffff",
      },

      red: {
        100: "#dbf5ee",
        200: "#b7ebde",
        300: "#94e2cd",
        400: "#70d8bd",
        500: "#4cceac",
        600: "#3da58a",
        700: "#2e7c67",
        800: "#1e5245",
        900: "#0f2922",
        1000: "#040509",
        1100: "#040509",
      },
      yellow: {
        100: "#FDF7E6",
        200: "#F8E7B2",
        300: "#F5DC8D",
        400: "#F1CC5A",
        500: "#EEC239",
        600: "#D5A307",
        700: "#BB8F06",
        800: "#A67F06",
        900: "#816204",
        1000: "#624B03",
        1100: "#312601",
      },
      green: {
        100: "#F0F6E7",
        200: "#CFE2B4",
        300: "#B8D590",
        400: "#98C15D",
        500: "#84B53D",
        600: "#5C940C",
        700: "#52840B",
        800: "#487409",
        900: "#385A07",
        1000: "#2A4405",
        1100: "#172603",
      },
      blue: {
        100: "#E7F6FD",
        200: "#B4E3F8",
        300: "#90D6F5",
        400: "#5EC3F0",
        500: "#3EB7ED",
        600: "#0D96D4",
        700: "#0C88C0",
        800: "#0A75A5",
        900: "#085B80",
        1000: "#064562",
        1100: "#032230",

      },
      headerColor: {
        modal: "#2084884d",
        // 200: "#B4E3F8",
        // 300: "#90D6F5",
        // 400: "#5EC3F0",
        // 500: "#3EB7ED",
        // 600: "#0D96D4",
        // 700: "#0C88C0",
        // 800: "#0A75A5",
        // 900: "#085B80",
        // 1000: "#064562",
        // 1100: "#032230",

      },
    }
    : {
      primary: {
        100: "#047070",
        200: "#BBDDDE",
        300: "#9ACDCE",
        400: "#6CB6BB",
        500: "#4FA8AA",
        600: "#208588",
        700: "#1D797C",
        800: "#19686A",
        900: "#135052",
        1000: "#0F3D3F",
        1100: "#082021",
      },
      gray: {
        100: "#F1F1F2",
        200: "#D3D3D6",
        300: "#BEBEC2",
        400: "#A0A0A6",
        500: "#8D8D95",
        600: "#67676F",
        700: "#5D5D65",
        800: "#505057",
        900: "#3E3E43",
        1000: "#2F2F33",
        1100: "#000000",
      },

      red: {
        100: "#dbf5ee",
        200: "#b7ebde",
        300: "#94e2cd",
        400: "#70d8bd",
        500: "#4cceac",
        600: "#3da58a",
        700: "#2e7c67",
        800: "#1e5245",
        900: "#0f2922",
        1000: "#040509",
        1100: "#040509",
      },
      yellow: {
        100: "#FDF7E6",
        200: "#F8E7B2",
        300: "#F5DC8D",
        400: "#F1CC5A",
        500: "#EEC239",
        600: "#D5A307",
        700: "#BB8F06",
        800: "#A67F06",
        900: "#816204",
        1000: "#624B03",
        1100: "#312601",
      },
      green: {
        100: "#F0F6E7",
        200: "#CFE2B4",
        300: "#B8D590",
        400: "#98C15D",
        500: "#84B53D",
        600: "#5C940C",
        700: "#52840B",
        800: "#487409",
        900: "#385A07",
        1000: "#2A4405",
        1100: "#172603",
      },
      blue: {
        100: "#E7F6FD",
        200: "#B4E3F8",
        300: "#90D6F5",
        400: "#5EC3F0",
        500: "#3EB7ED",
        600: "#0D96D4",
        700: "#0C88C0",
        800: "#0A75A5",
        900: "#085B80",
        1000: "#064562",
        1100: "#032230",

      },
      headerColor: {
        modal: "#2084884d",
        // 200: "#B4E3F8",
        // 300: "#90D6F5",
        // 400: "#5EC3F0",
        // 500: "#3EB7ED",
        // 600: "#0D96D4",
        // 700: "#0C88C0",
        // 800: "#0A75A5",
        // 900: "#085B80",
        // 1000: "#064562",
        // 1100: "#032230",

      },

    }),
});

export const themeSettings = (mode, theme, direction) => {
  const colors = tokens(mode);


  return {
    palette: {
      mode: mode,
      ...(mode === "dark"
        ? {
          primary: {
            main: colors.primary[500],
          },
          secondary: {
            main: colors.green[500],
          },
          neutral: {
            dark: colors.gray[700],
            main: colors.gray[500],
            light: colors.gray[100],
          },
          background: {
            // default: colors.primary[600],
            // paper: colors.primary[600], 
            //   // Drawer هم همین رو بگیره
          },
        }
        : {
          primary: {
            main: colors.primary[100],
          },
          secondary: {
            main: colors.green[500],
          },
          neutral: {
            dark: colors.gray[700],
            main: colors.gray[500],
            light: colors.gray[100],
          },
          background: {
            // default: "#fcfcfc",
            paper: "#fcfcfc",   // Drawer هم همین رو بگیره
          },
        }),
    },
    typography: {
  fontFamily:
    direction === "rtl"
      ? ["iransansFanum", "yekan"].join(",")
      : ["Inter", "yekan"].join(","),
},
    components: {
   
    },
    direction: direction,

  };
};



export const ColorModeContext = createContext({ toggleColorMode: () => { } });

export const useMode = () => {
  const localStorageMode = localStorage.getItem("rasamAplicationMod");
  const [mode, setMode] = useState("light");
  const themeHook = useTheme();
  const { i18n } = useTranslation();

  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prev) => (prev === "light" ? "dark" : "light"));
      },
    }),
    []
  );
  const direction = i18n.dir();
  const theme = useMemo(
    () =>
      createTheme(themeSettings(localStorageMode ? localStorageMode : "dark", themeHook, direction)),
    [localStorageMode, direction]
  );

  return [theme, colorMode];
};
